import { forwardRef, type ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** 'secondary' (outlined, the default) for utility actions; 'primary' (solid accent) for the one committing action on a page. */
  variant?: 'primary' | 'secondary';
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', type = 'button', className, ...rest },
  ref,
) {
  const variantClass = variant === 'primary' ? styles.primary : styles.secondary;
  const classes = className
    ? `${styles.button} ${variantClass} ${className}`
    : `${styles.button} ${variantClass}`;

  return <button ref={ref} type={type} className={classes} {...rest} />;
});
